import { Colors } from 'assets/colors';
import styled from 'styled-components';

export const StyledWrapper = styled.div`
  width: 100%;

  .box {
    background: color-mix(in srgb, ${Colors.primary1} 9%, white);
    border: 1px solid color-mix(in srgb, ${Colors.primary1} 22%, white);
    border-radius: 10px;
    padding: 16px 20px 8px;

    &-title {
      font-weight: 700;
      font-size: 16px;
      line-height: 22px;
      color: ${Colors.textPrimary1};
      padding-bottom: 12px;
      margin-bottom: 8px;
      border-bottom: 1px solid color-mix(in srgb, ${Colors.primary1} 18%, white);
    }
  }

  @media (max-width: 575.98px) {
    .box {
      padding: 14px 16px 8px;
    }
  }

  .details {
    display: flex;
    flex-direction: column;

    &-cell {
      margin-bottom: 16px;

      &-title {
        font-weight: 500;
        font-size: 14px;
        line-height: 18px;
        color: #717679;
        margin-bottom: 4px;
      }

      &-data {
        font-weight: 500;
        font-size: 14px;
        line-height: 18px;
        color: #131b1f;
        display: flex;
        align-items: center;
        gap: 8px;

        &--mono {
          font-family: monospace;
          font-size: 13px;
          cursor: default;
        }

        &--copyable {
          display: inline-flex;
          align-items: center;
          gap: 6px;

          .details-cell-data--mono {
            word-break: break-all;
          }
        }
      }
    }
  }

  .pos-action-btn {
    min-width: 160px;
    height: 42px;
    font-weight: 600;
    font-size: 14px;
  }

  .copy-btn {
    flex-shrink: 0;
    color: #717679;

    &:hover {
      color: ${Colors.primary1};
    }
  }
`;
